import * as React from "react";
import { DropTarget, DragDropContext } from "react-dnd";
import Draggable from "../Draggable";
import HTML5Backend from "react-dnd-html5-backend";

interface IDropableProps {
  className: string;
  reorder: (fromIndex: number, toIndex: number) => void;
  find: (id: number) => { item: any; index: number };
}

const dragTarget = { drop() {} };

class Dropable extends React.Component<IDropableProps, {}> {
  move(fromIndex: number, toIndex: number) {
    this.props.reorder(fromIndex, toIndex);
  }

  find(id: number): { item: any; index: number } {
    return this.props.find(id);
  }

  render() {
    const { connectDropTarget, draggables } = this.props as any;

    return connectDropTarget(
      <div className={this.props.className + " dropable"}>
        {React.Children.map(this.props.children, (child: any) => {
          // Note: This is a hack to inject move and find
          // props to all children if they're draggables
          if (child.type !== "div") {
            return React.cloneElement(child, {
              move: this.move.bind(this),
              find: this.find.bind(this)
            });
          } else {
            return child;
          }
        })}
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(
  DropTarget("Dropable", dragTarget, (connect: any) => ({
    connectDropTarget: connect.dropTarget()
  }))(Dropable)
) as any;



// WEBPACK FOOTER //
// ./client/modules/core/Dropable/index.tsx